module.exports = __webpack_public_path__ + "img/SEJ_Eventos_opciones.57bb3bfa.svg";